import {
  updateContractStatus,
  clearContractStatusErrors,
  clearContractStatusAction,
} from 'actions/contracts/contractStatusActions'
import AdminForm from 'components/admin/AdminForm'
import _ from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const ContractStatusUpdate = ({
  formId,
  params,
  setParams,
  closeModal,
  selected,
  setSelected,
}) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { lastAction, statusErrors } = useSelector(
    (state) => state.contractStatuses
  )

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractStatusAction())
      dispatch(clearContractStatusErrors())
    }
  }, [dispatch])

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        id: selected.id,
        name: selected.name,
      })
    }
  }, [params, setParams, selected])

  useEffect(() => {
    if (lastAction === 'edit') {
      closeModal()
    }
  }, [lastAction, closeModal])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return !_.size(params) ? (
    ''
  ) : (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()

        dispatch(updateContractStatus(params, selected))
      }}
      className="form container"
      noValidate
    >
      <AdminForm
        params={params}
        setParams={setParams}
        selected={selected}
        setSelected={setSelected}
        errors={statusErrors}
      />
    </form>
  )
}

export default ContractStatusUpdate
